export default __webpack_public_path__ + "static/media/LINK-USDT.7341c122.svg";